import {
  IndexDashboardImageComponentContaner,
  IndexDashboardImageComponentMainDiv,
} from "../../styles/indexcomponentsstyles/indexherodashboardcomponentstyles";
import { ReactComponent as ChatIcon } from "./assets/comment-regular-full.svg";
import { ReactComponent as NewIcon } from "./assets/plus-solid-full.svg";

import Bugziicon from "./assets/bugzi logo 2.png";
const IndexDashbordImageComponent = () => {
  return (
    <>
      <IndexDashboardImageComponentMainDiv>
        <IndexDashboardImageComponentContaner>
          <div>
            <div className="window-frame">
              <div className="sidebar">
                <div className="modal-header-holder ">
                  <div className="close-modal">
                    <div />
                    <div />
                    <div />
                  </div>
                  <div className="dashboard-logo-header">
                    <div className="dashboard-logo-holder">
                      <img src={Bugziicon} alt="bug"></img>
                    </div>
                    <div className="header-text">
                      <h4> Bugzi AI</h4>
                    </div>
                  </div>
                  <div className="dashboard-new-chat-button">
                    <div>
                      <div className="new-icon-holder">
                        <NewIcon className="small" fill="white" />{" "}
                      </div>
                      <div>New chat</div>
                    </div>
                  </div>
                </div>
                <div className="chat-history-modal">
                  {chathistorydata.map((item, index) => (
                    <div className="chat-modal" key={index + "chat"}>
                      <div className="chat-modal-icon-holder">
                        <ChatIcon
                          className="icon-medium"
                          fill=" #e3e3e3ff"
                        ></ChatIcon>
                      </div>
                      <div>
                        <p className="chat-modal-text">{item} </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="right"></div>
            </div>
          </div>
        </IndexDashboardImageComponentContaner>
      </IndexDashboardImageComponentMainDiv>
    </>
  );
};

const chathistorydata = [
  "Genarate react app",
  "Design lego game",
  "Design api Architecture ",
  "Create rest app",
  "Desing Mobile app",
  "fix code issues ",
  "complete  source code ",
  "Find code issue ",
  "Find issue ",
];
export default IndexDashbordImageComponent;
